import { Building, Truck, Users } from "lucide-react";
import { useGetIdentity } from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";

import { FilterCategory } from "../filters/FilterCategory";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { sizes } from "./sizes";
import { ResponsiveFilters, type CollapsedIcon } from "../misc/ResponsiveFilters";
import { useIsMobile } from "@/hooks/use-mobile";

export const CompanyListFilter = () => {
  const { identity } = useGetIdentity();
  const { companySectors } = useConfigurationContext();
  const isMobile = useIsMobile();

  const collapsedIcons: CollapsedIcon[] = [
    { icon: <Building className="w-4 h-4" />, label: "Size" },
    { icon: <Truck className="w-4 h-4" />, label: "Sector" },
    { icon: <Users className="w-4 h-4" />, label: "Assigned to" },
  ];

  return (
    <ResponsiveFilters collapsedIcons={collapsedIcons}>
      <FilterCategory icon={<Building className="h-4 w-4" />} label="Size">
        {sizes.map((size) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={size.name}
            key={size.name}
            value={{ size: size.id }}
            size={isMobile ? "lg" : undefined}
          />
        ))}
      </FilterCategory>

      <FilterCategory icon={<Truck className="h-4 w-4" />} label="Sector">
        {companySectors.map((sector) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={sector.label}
            key={sector.value}
            value={{ sector: sector.value }}
            size={isMobile ? "lg" : undefined}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label="Assigned to"
      >
        <ToggleFilterButton
          className="w-full justify-between h-10 md:h-8"
          label={"Me"}
          value={{ sales_id: identity?.id }}
          size={isMobile ? "lg" : undefined}
        />
      </FilterCategory>
    </ResponsiveFilters>
  );
};
